module.exports = __webpack_public_path__ + "static/img/sorry.e6aa1bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sorry.png
// module id = 5Ge2
// module chunks = 2